<template>
    <Box :products="products" :loading="loading" :is-guest="true"></Box>
</template>
<script>

import InfoBox from "./components/InfoBox";
import InfoRating from "./components/InfoRating";
import Bookmark from "./components/Bookmark";
import PageLoading from "./components/PageLoading";
import DateRangeButton from "../../../shared/Components/DateRangeButton";
import Box from "./components/Box";
import TrendingProductUpdateTrendNotice from "./components/TrendingProductUpdateTrendNotice";
import UserSearchIcon from "@s/Components/Icons/UserSearchIcon";

export default {
    name: 'GuestProductBox',
    components: {
        Box,
        DateRangeButton,
        PageLoading,
        Bookmark, InfoRating, InfoBox,
        TrendingProductUpdateTrendNotice,
        UserSearchIcon
    },
    props: ["products", "data", "filters", "date"],
    data() {
      return {
          loading: false,
          f: {... this.filters},
          routes: __st.routes,
          dateTitle: 'Date',
          dateOptions: {
              ranges: {
                  'Today': [moment(), moment()],
                  'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                  'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                  'Last 10 Days': [moment().subtract(9, 'days'), moment()],
                  'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                  'This Month': [moment().startOf('month'), moment().endOf('month')],
              }
          },

          exp: {
              modalId:  'box-export-modal',
              form: {
                  export_type: 'csv',
                  export_limit: this.data.rppLimit,
                  aliexpress: 0,
                  amazon: 0,
                  alibaba: 0
              }
          }
      }
    },
    created() {

        if(this.date.startDate) {
            this.dateOptions.startDate = this.date.startDate;
        }

        if(this.date.endDate) {
            this.dateOptions.endDate = this.date.endDate;
        }

        setTimeout(() => {
            [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
                .map((popoverTriggerEl) => new bootstrap.Popover(popoverTriggerEl));
        }, 300)
    },
    methods: {
        submit() {
            this.f.rf = 1;
            var that = this;
            let queryString = Object.keys(this.f).map(function(key) {
                if(that.f[key] == null) {
                    that.f[key] = '';
                }
                return key + '=' + that.f[key]
            }).join('&');
            const url = this.data.currentUrl+"?"+queryString;
            this.$inertia.visit(url, {
                only: ['products',"filters", "date","date", "pageTitle", "recordInfo"],
                onStart: (visit) => { this.loading = true },
                onFinish: (visit) => { this.loading = false },
            },
            )
        },

        clearFilters() {
            const filters =  {... this.filters};
            filters.date = '' ;
            this.dateOptions.startDate = '';
            this.dateOptions.endDate = '';
            filters.category = '-1';
            filters.title = '';
            this.f = filters;
            this.f.rf = 0;
        },


        showExport() {
            (new bootstrap.Modal(document.getElementById(this.exp.modalId))).show();
        },

        exportData(){
            var that = this;
            let queryString = Object.keys(this.f).map(function(key) {
                if(that.f[key] == null) {
                    that.f[key] = '';
                }
                return key + '=' + that.f[key]
            }).join('&');
            location.href = this.data.currentUrl+"?"+queryString+"&export=1&export_type="+this.exp.form.export_type+"&export_limit="+this.exp.form.export_limit+"&amazon="+this.exp.form.amazon+"&aliexpress="+this.exp.form.aliexpress+"&alibaba="+this.exp.form.alibaba;
            const modal = bootstrap.Modal.getInstance(document.getElementById(this.exp.modalId))
            modal.hide();

            this.exp.form.aliexpress = 0;
            this.exp.form.alibaba = 0;
            this.exp.form.amazon = 0;

        },
    }
}
</script>

<style>
[v-cloak] { display:none; }
</style>

